import { usePathname } from 'expo-router';
import { useEffect, useRef } from 'react';

import { useCRMEventsContext } from 'state/crm-events';
import { ServiceMode, useServiceModeContext } from 'state/service-mode';
import { useStoreContext } from 'state/store';
import { useFlag } from 'utils/launchdarkly';

export default function useLogPageView() {
  const pathname = usePathname();
  const lastLoggedPathname = useRef('');
  const { logPageView } = useCRMEventsContext();
  const { store } = useStoreContext();
  const { serviceMode, deliveryFees } = useServiceModeContext();
  const fees = serviceMode === ServiceMode.DELIVERY ? deliveryFees : undefined;


  const isExplicitDonationEnabled = useFlag('explicit-donation');

  useEffect(() => {
    if (lastLoggedPathname.current !== pathname) {
      const featureFlags = {
        isSimplyBetterOffersUIEnabled: true,

        isExplicitDonationEnabled,
      };

      logPageView(pathname, store, fees ?? undefined, featureFlags);
      lastLoggedPathname.current = pathname;
    }
  }, [
    fees,
    logPageView,
    pathname,
    store,
    isExplicitDonationEnabled,
  ]);
}
